if (!customElements.get("eck-recently-viewed")) {
  customElements.define(
    "eck-recently-viewed",
    class EckRecentlyViewed extends HTMLElement {
      constructor() {
        super();
        this.storageKey = "eck:recently-viewed";
        this.maxItems = 5;
        this.maxFetch = 4;
      }

      connectedCallback() {
        this.store = window.EckUtils.safeStorage("local");
        this.recordCurrent();
        this.observe();
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }

      readItems() {
        return this.store.read(this.storageKey, []);
      }

      recordCurrent() {
        if (!this.dataset.productId || !this.store.available()) return;
        const productId = parseInt(this.dataset.productId, 10);
        if (isNaN(productId)) return;
        let items = this.readItems().filter((id) => id !== productId);
        items.unshift(productId);
        items = items.slice(0, this.maxItems);
        this.store.write(this.storageKey, items);
      }

      buildQuery() {
        let items = this.readItems();
        if (this.dataset.productId) {
          const current = parseInt(this.dataset.productId, 10);
          items = items.filter((id) => id !== current);
        }
        return items
          .slice(0, this.maxFetch)
          .map((id) => "id:" + id)
          .join(" OR ");
      }

      observe() {
        this.observer = window.EckUtils.revealOnIntersect(this, () => this.loadProducts(), { rootMargin: "600px" });
      }

      loadProducts() {
        const query = this.buildQuery();
        if (!query) return;
        const url = this.dataset.url + encodeURIComponent(query);
        window.EckUtils.fetchSectionInto(this, url, "eck-recently-viewed");
      }
    },
  );
}
